import axios from 'axios';
import moment from 'moment';
import setIndicatorColor from 'src/app/main/dashboard/table/utils';
import { getMetricThresholds, metricThresholds } from '../../main/dashboard/utils';
import { clientAxios } from '../../configs/axios';
import utils from './utils';
import types from './types';

const {
  dashboardIrregularNodesTypes,
  dashboardCaidasTypes,
  dashboardResponseTimeTypes,
  dashboardGeneralTableTypes,
  dashboardTopInterfacesTypes,
  dashboardMetricTypes,
  dashboardFirstSectionTypes,
  nodeDetailsGeneralInfoTypes,
  nodeDetailsInterfacesTypes,
  nodeDetailsPercentAvailabilityTypes,
  dashboardChartNodesTypes,
  dashboardInterfaceSelectionTypes,
  nodeDetailsSetFiltersTypes,
  inmuebleDeviceNodesTypes,
  toggleDarkModeTypes,
  metricThresholdTypes,
  dashboardChartsThresholdsTypes
} = types;

const { structureNodeData, formatDates } = utils;

const API_URL = process.env.REACT_APP_API_URL;

export function getDashboard() {
  return async (dispatch) => {
    dispatch(dashboardInit());
  };
}

export function getDashboardFirstSection(filters) {
  return async (dispatch) => {
    dispatch(dashboardFirstSectionInit());
    try {
      const getTotalResponse = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getTotal`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          nodeId: filters?.nodo || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        },
        // {
        //   signal: AbortSignal.timeout(9000),
        // }
      );
      const getDisponibilidadResponse = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getDisponibilidad`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          amarillo: false,
          gris: false,
          rojo: false,
          verde: false,
          nodeId: filters?.nodo || 0,
          tipoInmuebleId: 0,
          metricaId: 0,
          paginador: {
            limit: 0,
            pagina: 0,
          },
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        },
        // {
        //   signal: AbortSignal.timeout(9000),
        // }
      );
      const getAnchoBandaEntrada = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getAnchoBandaEntrada`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          amarillo: false,
          gris: false,
          rojo: false,
          verde: false,
          nodeId: filters?.nodo || 0,
          tipoInmuebleId: 0,
          metricaId: 0,
          paginador: {
            limit: 0,
            pagina: 0,
          },
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        },
        // {
        //   signal: AbortSignal.timeout(9000),
        // }
      );
      const getAnchoBandaSalida = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getAnchoBandaSalida`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          amarillo: false,
          gris: false,
          rojo: false,
          verde: false,
          nodeId: filters?.nodo || 0,
          tipoInmuebleId: 0,
          metricaId: 0,
          paginador: {
            limit: 0,
            pagina: 0,
          },
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        },
        // {
        //   signal: AbortSignal.timeout(9000),
        // }
      );

      const getTotalResponseData = getTotalResponse.data.data;
      const getDisponibilidadResponseData = getDisponibilidadResponse.data.data;
      const getAnchoBandaEntradaData = getAnchoBandaEntrada.data.data[0];
      const getAnchoBandaSalidaData = getAnchoBandaSalida.data.data[0];

      const defaultValue = (value, percent, bandwidth) => {
        if (bandwidth) {
          const bandwidthValue = Number(value) / 1000000;
          return bandwidthValue.toFixed(3);
        }
        if (percent) {
          return Number(value).toFixed(2);
        }
        return value || 0;
      };

      const indicatorsData = [
        {
          total: defaultValue(getTotalResponseData?.totalInmuebles?.total),
          up: defaultValue(getTotalResponseData?.totalInmuebles?.verde),
          down: defaultValue(getTotalResponseData?.totalInmuebles?.rojo),
          warning: defaultValue(getTotalResponseData?.totalInmuebles?.amarillo),
          unregistered: defaultValue(getTotalResponseData?.totalInmuebles?.gris),
        },
        {
          total: defaultValue(getTotalResponseData?.totalDispositivos?.total),
          up: defaultValue(getTotalResponseData?.totalDispositivos?.verde),
          down: defaultValue(getTotalResponseData?.totalDispositivos?.rojo),
          warning: defaultValue(getTotalResponseData?.totalDispositivos?.amarillo),
          unregistered: defaultValue(getTotalResponseData?.totalDispositivos?.gris),
        },
        {
          total: `${defaultValue(Number(getDisponibilidadResponseData?.disponibilidad), true)}%`,
          up: defaultValue(getDisponibilidadResponseData?.verde),
          down: defaultValue(getDisponibilidadResponseData?.rojo),
          warning: defaultValue(getDisponibilidadResponseData?.amarillo),
          unregistered: defaultValue(getDisponibilidadResponseData?.gris),
        },
        {
          total: `${defaultValue(Number(getAnchoBandaEntradaData?.anchobanda), true, true) % 1000000} Mbps`,
          up: defaultValue(getAnchoBandaEntradaData?.verde),
          down: defaultValue(getAnchoBandaEntradaData?.rojo),
          warning: defaultValue(getAnchoBandaEntradaData?.amarillo),
          unregistered: defaultValue(getAnchoBandaEntradaData?.gris),
        },
        {
          total: `${defaultValue(Number(getAnchoBandaSalidaData?.anchobanda), true, true) % 1000000} Mbps`,
          up: defaultValue(getAnchoBandaSalidaData?.verde),
          down: defaultValue(getAnchoBandaSalidaData?.rojo),
          warning: defaultValue(getAnchoBandaSalidaData?.amarillo),
          unregistered: defaultValue(getAnchoBandaSalidaData?.gris),
        },
      ];
      dispatch(dashboardFirstSectionSuccess(indicatorsData));
    } catch (error) {
      dispatch(dashboardErrorFirstSection(error));
    }
  };
}

export function getDashboardDevices(filters) {
  return async (dispatch) => {
    dispatch(dashboardInitDevices());
    try {
      const response = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getGrupoInmueble`,
        {
          amarillo: false,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          gris: false,
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          metricaId: 0,
          nodeId: filters?.nodo || 0,
          paginador: {
            limit: 0,
            pagina: 0,
          },
          regionId: filters?.region || 0,
          rojo: false,
          tipoInmuebleId: 0,
          verde: false,
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        },
        // {
        //   signal: AbortSignal.timeout(9000),
        // }
      );
      const data = await response.data.data;

      let grupoInmueblesDataArray;
      let inmueblesDataArray;
      if (data.dsInmueble.length === 0) {
        inmueblesDataArray = [
          {
            tipoinmuebleid: '1',
            dsinmueble: 'Sin Datos',
            total: 0,
            verde: 0,
            amarillo: 0,
            rojo: 0,
            gris: 0,
          },
        ];
      } else {
        const imueblesObject = {};
        data.dsInmueble.forEach((inmueble) => {
          if (inmueble.tipoinmuebleid in imueblesObject) {
            imueblesObject[inmueble.tipoinmuebleid] = {
              ...imueblesObject[inmueble.tipoinmuebleid],
              [inmueble.color]: Number(inmueble.total),
            };
          } else {
            imueblesObject[inmueble.tipoinmuebleid] = {
              tipoinmuebleid: inmueble.tipoinmuebleid,
              dsinmueble: inmueble.dsinmueble,
              verde: 0,
              amarillo: 0,
              rojo: 0,
              gris: 0,
              [inmueble.color]: Number(inmueble.total),
            };
          }
        });
        inmueblesDataArray = Object.values(imueblesObject);
      }
      if (data.dsGrupoInmueble.length === 0) {
        grupoInmueblesDataArray = [
          {
            grupoinmuebleid: '1',
            dsgrupoinmueble: 'Sin Datos',
            total: 0,
            verde: 0,
            amarillo: 0,
            rojo: 0,
            gris: 0,
          },
        ];
      } else {
        const grupoInmueblesObject = {};
        data.dsGrupoInmueble.forEach((grupoInmueble) => {
          if (grupoInmueble.grupoinmuebleid in grupoInmueblesObject) {
            grupoInmueblesObject[grupoInmueble.grupoinmuebleid] = {
              ...grupoInmueblesObject[grupoInmueble.grupoinmuebleid],
              [grupoInmueble.color]: Number(grupoInmueble.total),
            };
          } else {
            grupoInmueblesObject[grupoInmueble.grupoinmuebleid] = {
              grupoinmuebleid: grupoInmueble.grupoinmuebleid,
              dsgrupoinmueble: grupoInmueble.dsgrupoinmueble,
              verde: 0,
              amarillo: 0,
              rojo: 0,
              gris: 0,
              [grupoInmueble.color]: Number(grupoInmueble.total),
            };
          }
        });
        grupoInmueblesDataArray = Object.values(grupoInmueblesObject);
      }
      dispatch(
        dashboardDevicesSuccess({
          tipoInmuebles: inmueblesDataArray,
          gruposInmueble: grupoInmueblesDataArray,
        })
      );
    } catch (error) {
      dispatch(dashboardErrorDevices(error));
    }
  };
}

export function getDashboardProperty() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/ms-dashboard/tablero/chartsinmuebles/', 
      // {
      //   signal: AbortSignal.timeout(9000),
      // }
      );
      const data = await response.data;
      dispatch(dashboardPropertySuccess(data));
    } catch (error) {
      dispatch(dashboardErrorProperty(error));
    }
  };
}

export function getDashboardFilters() {
  return async (dispatch) => {
    dispatch(dashboardInitFilters());
    try {
      const responseRegiones = await axios.get(`${API_URL}/ms-catalogos/filtros/region`);
      const responseInmuebles = await axios.get(`${API_URL}/ms-catalogos/filtros/inmueble`);
      const responseGrupos = await axios.get(`${API_URL}/ms-catalogos/filtros/grupoinmueble`);
      const responseNodos = await axios.get(`${API_URL}/ms-catalogos/filtros/nodo`);
      
      const inmueblesData = await responseInmuebles.data;
      const regionesData = await responseRegiones.data.data;
      const gruposData = await responseGrupos.data.data;
      const nodosData = await responseNodos.data.data
      
      dispatch(
        dashboardFiltersSuccess({
          inmuebles: inmueblesData,
          regiones: regionesData,
          grupos: gruposData,
          nodos: nodosData
        })
      );
    } catch (error) {
      dispatch(dashboardFiltersError(error));
    }
  };
}

export function setDashboardFiltersSelected(filtersAdded) {
  return async (dispatch) => {
    try {
      if (!filtersAdded) {
        dispatch(dashboardFiltersSelectionSuccess({}));
      } else {
        const filters = { ...filtersAdded };
        dispatch(dashboardFiltersSelectionSuccess(filters));
      }
    } catch (error) {
      dispatch(dashboardFiltersSelectionError());
    }
  };
}

export function setDashboardNodeSelected(redirectPath, nodeSelected) {
  return async (dispatch) => {
    dispatch(dashboardNodeSelectionInit());
    dispatch(dashboardNodeSelectionSuccess({ redirectPath, nodeSelected }));
  };
}

export function setDashboardInterfaceSelected(nodeId, nodeName, filters) {
  return async (dispatch) => {
    dispatch(dashboardInterfaceSelectionInit());
    try {

      const requestBody = {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || moment().format('Y-MM-DD HH:mm:00'),
        fechaIni: filters?.fechaIni || moment().subtract(24, 'hour').format('Y-MM-DD HH:mm:00'),
        nodeId: nodeId || 0,
        metricaId: 0,
        amarillo: false,
        gris: false,
        verde: false,
        rojo: false,
        tipoInmuebleId: 0,
      };

      // Ejecutar todas las llamadas en paralelo
      const [responseMetricas, responseAnchoBanda, responseMetricsInt] = await Promise.all([
        axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/getMetricas`, requestBody),
        axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/metricas/anchoBanda`, requestBody),
        axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/getMetricasByInterface`, requestBody),
      ]);

      const metricasData = await responseMetricas.data.data;
      const metricasObj = {};

      if (metricasData) {
        metricasData.forEach((node) => {
          if (metricasObj[node.metricaId]) {
            metricasObj[node.metricaId] = [...metricasObj[node.metricaId], { ...node, fecha: formatDates(node.fecha) }];
          } else {
            metricasObj[node.metricaId] = [{ ...node, fecha: formatDates(node.fecha) }];
          }
        });
      }

      const anchoBandaData = await responseAnchoBanda.data.data;
      const anchoBandaObj = {};
      let interfaces = [];
      const existingInterfaces = new Set(); // Set para rastrear interfaces únicas

      if (responseAnchoBanda.status !== 404) {
        anchoBandaData.forEach((node) => {
          if (anchoBandaObj[node.interfaceid]) {
            anchoBandaObj[node.interfaceid] = [
              ...anchoBandaObj[node.interfaceid],
              {
                ...node,
                fecha: formatDates(node.fecha),
                dslectura1: Number(node.anchobandasubida).toFixed(2),
                dslectura2: Number(node.anchobandabajada).toFixed(2),
              },
            ];
          } else {
            anchoBandaObj[node.interfaceid] = [
              {
                ...node,
                fecha: formatDates(node.fecha),
                dslectura1: Number(node.anchobandasubida).toFixed(2),
                dslectura2: Number(node.anchobandabajada).toFixed(2),
              },
            ];
            if (!existingInterfaces.has(node.interfaceid)) {
              interfaces = interfaces.concat({ value: node.interfaceid, label: node.dsinterface });
              existingInterfaces.add(node.interfaceid); // Agregar al Set de interfaces existentes
            }
          }
        });
      }

      // Procesar datos de responseMetricsInt
      const metricsInterfaceData = responseMetricsInt.data.data;
      const metricsInterfaceDataObj = {};
      const metricsErrorInterfaceDataObj = {};
      const metricsDescInterfaceDataObj = {};

      if (metricsInterfaceData) {
        metricsInterfaceData.forEach((node) => {
          if (!metricsInterfaceDataObj[node.interfaceid]) metricsInterfaceDataObj[node.interfaceid] = [];
          metricsInterfaceDataObj[node.interfaceid].push({
            ...node,
            fecha: moment(node.fecha),
            dslectura1: Number(node.bandwidthin).toFixed(2),
            dslectura2: Number(node.bandwidthout).toFixed(2),
          });
          if (!metricsErrorInterfaceDataObj[node.interfaceid]) metricsErrorInterfaceDataObj[node.interfaceid] = [];
          metricsErrorInterfaceDataObj[node.interfaceid].push({
            ...node,
            fecha: moment(node.fecha),
            dslectura1: Number(node.errorin).toFixed(2),
            dslectura2: Number(node.errorout).toFixed(2),
          });
          if (!metricsDescInterfaceDataObj[node.interfaceid]) metricsDescInterfaceDataObj[node.interfaceid] = [];
          metricsDescInterfaceDataObj[node.interfaceid].push({
            ...node,
            fecha: moment(node.fecha),
            dslectura1: Number(node.discardsin).toFixed(2),
            dslectura2: Number(node.discardsout).toFixed(2),
          });
          if (!existingInterfaces.has(node.interfaceid)) {
            interfaces.push({ value: node.interfaceid || node.dsinterface, label: node.dsinterface });
            existingInterfaces.add(node.interfaceid);
          }
        });
      }
      // Ordenar y formatear las fechas de metricsInterfaceDataObj
      if (Object.keys(metricsInterfaceDataObj).length > 0) {
        Object.keys(metricsInterfaceDataObj).forEach((interfaceid) => {
          metricsInterfaceDataObj[interfaceid] = metricsInterfaceDataObj[interfaceid].sort((a, b) => a.fecha.diff(b.fecha))
            .map((metricRegister) => ({
              ...metricRegister,
              fecha: formatDates(metricRegister.fecha),
            }));
        });
      }
      
      dispatch(
        dashboardInterfaceSelectionSuccess({
          nodeSelected: nodeName,
          interfaces,
          metricasGraphicData: metricasObj,
          anchoBandaGraphicData: anchoBandaObj,
          metricsInterfaceData: metricsInterfaceDataObj,
          metricsErrorInterfaceData: metricsErrorInterfaceDataObj,
          metricsDescInterfaceData: metricsDescInterfaceDataObj
        })
      );
    } catch (error) {
      dispatch(dashboardInterfaceSelectionError(error));
    }
  };
}

export function setDashboardDrillInterfaceSelected(interfaceSelected) {
  return async (dispatch) => {
    dispatch(dashboardDrillInterfaceSelectionInit());
    dispatch(dashboardDrillInterfaceSelectionSuccess(interfaceSelected));
  };
}

export function getDashboardIrregularNodes(filters) {
  return async (dispatch) => {
    dispatch(dashboardIrregularNodesInit());
    try {
      const response = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getTopDieznodosIrregulares`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          nodeId: filters?.nodo || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
        }
      );
      const data = await response.data.data;
      const irregularNodes = {
        highMemoryUsage: structureNodeData(data.TopDiezAltoUsoMemoria),
        highCpuUsage: structureNodeData(data.TopDiezAltoUsoCPU),
        unavailable: structureNodeData(data.TopDiezIndisponibilidad, true),
        highLossPackage: structureNodeData(data.TopDiezPerdidaPaquetes),
      };
      dispatch(dashboardIrregularNodesSuccess(irregularNodes));
    } catch (error) {
      dispatch(dashboardIrregularNodesError(error));
    }
  };
}

export function getDashboardCaidas(filters) {
  return async (dispatch) => {
    dispatch(dashboardCaidasInit());
    try {
      const response = await axios.post(
        `${API_URL}/ms-catalogos/filtros/StatusNodoByParams`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          nodeId: filters?.nodo || 0,
        }
      );
      const data = await response.data.data;
      const nodes = data
        .map(nodo => ({
          ...nodo,
          id: nodo.nodoId,
        }))
      dispatch(dashboardCaidasSuccess(nodes))
    } catch (error) {
      dispatch(dashboardCaidasError(error));
    }
  };
}

export function getChartsThresholds(filters) {
  return async (dispatch) => {
    dispatch(dashboardChartsThresholdsInit());
    try {
      const response = await axios.get(
        `${API_URL}/ms-catalogos/filtros/umbral/ByMetricas`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          nodeId: filters?.nodo || 0,
        }
      );
      const data = await response.data;
      dispatch(dashboardChartsThresholdsSuccess(data))
    } catch (error) {
      dispatch(dashboardChartsThresholdsError(error));
    }
  };
}

export function getDashboardResponseTime(filters) {
  return async (dispatch) => {
    dispatch(dashboardResponseTimeInit());
    try {
      const response = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/metrica/geResponseTime`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          nodeId: filters?.nodo || 0,
        }
      );
      const data = await response.data.data;
      const nodes = data
        .map(nodo => ({
          ...nodo,
          id: nodo.nodeid,
        }))
        .sort((a, b) => {
          return parseInt(a.tiempoRespuesta, 10) - parseInt(b.tiempoRespuesta, 10);
        });
      dispatch(dashboardResponseTimeSuccess(nodes))
    } catch (error) {
      dispatch(dashboardResponseTimeError(error));
    }
  };
}

export function getDashboardGeneralTable(filters, page = 0, size = 1000) {
  return async (dispatch) => {
    dispatch(dashboardGeneralTableInit());
    try {
      const colorValues = {
        'green-primary': 1,
        'yellow-primary': 2,
        'red-primary': 3,
        'grey-primary': 0,
        default: 0,
      };
      const response = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getInformacionGeneral`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          nodeId: filters?.nodo || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          amarillo: false,
          rojo: false,
          verde: false,
          tipoInmuebleId: 0,
        }
      );
      let data = await response.data.data;
      const currentMetricThresholds = await getMetricThresholds();
      const calculateIndicatorsTotal = (dataItem) => {
        return (
          colorValues[setIndicatorColor(Number(dataItem.memoria), 'memoria', currentMetricThresholds)] +
          colorValues[setIndicatorColor(Number(dataItem.cpu), 'cpu', currentMetricThresholds)] +
          // colorValues[dataItem.estadoequipo || 'default'] +
          colorValues[setIndicatorColor(Number(dataItem.latencia), 'latencia', currentMetricThresholds)] +
          // colorValues[dataItem.paquetes || 'default'] +
          // colorValues[dataItem.temperatura || 'default'] +
          // colorValues[dataItem.powersupply || 'default'] +
          // colorValues[dataItem.jitter || 'default'] +
          // colorValues[dataItem.jitter2 || 'default'] +
          colorValues[setIndicatorColor(Number(dataItem.disponibilidad), 'disponibilidad', currentMetricThresholds)]
          // colorValues[dataItem.mos || 'default']
        );
      };
      data = data.map((dataItem) => ({ ...dataItem, totalDevices: calculateIndicatorsTotal(dataItem) }));
      dispatch(dashboardGeneralTableSuccess(data));
    } catch (error) {
      dispatch(dashboardGeneralTableError(error));
    }
  };
}

export function getDashboardTopInterfaces(filters) {
  return async (dispatch) => {
    dispatch(dashboardTopInterfacesInit());
    try {
      const response = await axios.post(
        `${API_URL}/ms-dashboard/tablero/indicadores/getTopDiezNodos`,
        {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          nodeId: filters?.nodo || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
        }
      );
      const data = await response.data.data;
      let formattedData = [];
      data.forEach((dataItem, index) => {
        formattedData = formattedData.concat({ ...dataItem, id: index });
      });

      dispatch(dashboardTopInterfacesSuccess(formattedData));
    } catch (error) {
      dispatch(dashboardTopInterfacesError(error));
    }
  };
}

export function getDashboardMetrics() {
  return async (dispatch) => {
    dispatch(dashboardMetricInit());
    try {
      const response = await axios.get(`${API_URL}/ms-catalogos/filtros/niveles/servicio/metricas`);
      const data = await response.data.data;
      dispatch(dashboardMetricSuccess(data));
    } catch (error) {
      dispatch(dashboardMetricError(error));
    }
  };
}

export function getNodeDetailsPercentAvailability(nodeID, range, filters) {
  return async (dispatch) => {
    dispatch(nodeDetailsPercentAvailabilityInit());
    let fechas;
    if (range === 'filters') {
      fechas = {
        fechaIni: filters.fechaIni,
        fechaFin: filters.fechaFin,
      };
    } else if (range === 'mid') {
      fechas = {
        fechaIni: moment().subtract(12, 'hours').format('Y-MM-DD HH:mm:00'),
        fechaFin: moment().format('Y-MM-DD HH:mm:00'),
      };
    } else {
      fechas = {
        fechaIni: moment().subtract(24, 'hours').format('Y-MM-DD HH:mm:00'),
        fechaFin: moment().format('Y-MM-DD HH:mm:00'),
      };
    }

    try {
      const response = await axios.post(`${API_URL}/ms-dashboard/tablero/procentaje/disponibilidad/interfaces`, {
        grupoInmuebleId: 0,
        inmuebleId: 0,
        regionId: 0,
        ...fechas,
        nodeId: nodeID,
      });
      let data = await response?.data;
      if (response?.status === 404 || !data) {
        dispatch(nodeDetailsPercentAvailabilitySuccess([{ fecha: 'Sin Datos', disponibilidad: 0 }]));
      } else {
        data = data?.data.map((nodeRegister) => ({ ...nodeRegister, fecha: moment(nodeRegister.fecha) }));
        data = data.sort((a, b) => a.fecha.diff(b.fecha));
        data = data.map((nodeRegister) => ({ ...nodeRegister, fecha: formatDates(nodeRegister.fecha) }));

        dispatch(nodeDetailsPercentAvailabilitySuccess(data || []));
      }
    } catch (error) {
      dispatch(nodeDetailsPercentAvailabilityError(error));
    }
  };
}

export function getNodeDetails(nodeID, filters) {
  return async (dispatch) => {
    dispatch(nodeDetailsInterfacesInit());
    dispatch(nodeDetailsGeneralInfoInit());
    // dispatch(nodeDetailsPercentAvailabilityInit());
    try {
      // FETCHING NODE DETAILS
      const nodeDetailsResponse = await axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/nodos/informacion`, {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId: nodeID,
      });
      const nodeDetailsData = await nodeDetailsResponse.data.data;

      // FETCHING INTERFACES OF NODE
      const nodeInterfacesResponse = await axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/interfaces`, {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId: nodeID,
      });
      let interfacesData = await nodeInterfacesResponse.data.data;
      if (interfacesData) {
        interfacesData = interfacesData.map((interfaceData) => ({
          ...interfaceData,
          anchobandasubidaContratado: Number(interfaceData.anchobandasubidaContratado).toFixed(2) || 0,
          anchobandabajadaContratado: Number(interfaceData.anchobandabajadaContratado).toFixed(2) || 0,
          anchobandasubida: Number(interfaceData.anchobandasubida).toFixed(2) || 0,
          anchobandabajada: Number(interfaceData.anchobandabajada).toFixed(2) || 0,
        }));
      }
      dispatch(nodeDetailsInterfacesSuccess(interfacesData || []));
      const generalInfoResult = {
        generalInfo: Array.isArray(nodeDetailsData) ? nodeDetailsData[0] : nodeDetailsData,
      };
      if (nodeDetailsData) {
        generalInfoResult.metricsGraphic = {
          nodeSelected: Array.isArray(nodeDetailsData) ? nodeDetailsData[0].dsnodo : nodeDetailsData?.dsnodo,
        };
      }
      dispatch(nodeDetailsGeneralInfoSuccess(generalInfoResult));
      // dispatch(nodeDetailsPercentAvailabilitySuccess(data));
    } catch (error) {
      dispatch(nodeDetailsIndicatorsError(error));
    }
  };
}

export function getChartNodes({ value, category, color, filters }) {
  return async (dispatch) => {
    dispatch(dashboardChartNodesInit());
    try {
      let response;
      if (category === 'grupo') {
        response = await axios.post(
          `${API_URL}/ms-dashboard/tablero/indicadores/nodos/porgrupo`,
          {
            grupoInmuebleId: value,
            inmuebleId: filters?.inmueble || 0,
            nodeId: filters?.nodo || 0,
            regionId: filters?.region || 0,
            fechaFin: filters?.fechaFin || '',
            fechaIni: filters?.fechaIni || '',
            rojo: color === 'rojo',
            verde: color === 'verde',
            amarillo: color === 'amarillo',
            gris: color === 'gris',
          }
        );
      } else {
        response = await axios.post(
          `${API_URL}/ms-dashboard/tablero/indicadores/nodos/porinmueble`,
          {
            inmuebleId: filters?.inmueble || 0,
            tipoInmuebleId: value,
            grupoInmuebleId: filters?.grupo || 0,
            nodeId: filters?.nodo || 0,
            regionId: filters?.region || 0,
            fechaFin: filters?.fechaFin || '',
            fechaIni: filters?.fechaIni || '',
            rojo: color === 'rojo',
            verde: color === 'verde',
            amarillo: color === 'amarillo',
            gris: color === 'gris',
          }
        );
      }
      let data = await response.data.data;
      data = data.map((dataItem, index) => ({ ...dataItem, id: index }));
      dispatch(dashboardChartNodesSuccess(data));
    } catch (error) {
      dispatch(dashboardChartNodesError(error));
    }
  };
}

export function setNodeDetailsFilters(filtersAdded) {
  return async (dispatch) => {
    dispatch(nodeDetailsSetFiltersInit());
    try {
      if (!filtersAdded) {
        dispatch(nodeDetailsSetFiltersSuccess({}));
      } else {
        let filters = { ...filtersAdded };
        if ('tiempo' in filtersAdded) {
          if (filtersAdded.tiempo.fechaIni === 'update') {
            filters = {
              ...filters,
               fechaFin: moment().format('Y-MM-DD HH:mm:00'),
               fechaIni: moment().subtract(10, 'minutes').format('Y-MM-DD HH:mm:00'),
            };
          } else {
            filters = { ...filters, ...filtersAdded.tiempo };
          }
          delete filters.tiempo;
        }
        dispatch(nodeDetailsSetFiltersSuccess(filters));
      }
    } catch (error) {
      dispatch(nodeDetailsSetFiltersError());
    }
  };
}

export function getInmuebleOrDeviceNodes(category, color, filters) {
  return async (dispatch) => {
    dispatch(dashboardGetInmuebleDeviceNodesInit());
    try {
      const response = await axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/detalle/${category}`, {
        amarillo: color === 'amarillo',
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        gris: color === 'gris',
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        metricaId: 0,
        nodeId: filters?.nodo || 0,
        paginador: {
          limit: 0,
          pagina: 0,
        },
        regionId: filters?.region || 0,
        rojo: color === 'rojo',
        tipoInmuebleId: 0,
        verde: color === 'verde',
      });
      let data = await response?.data?.data;
      if (response?.status === 404 || !data) {
        dispatch(dashboardGetInmuebleDeviceNodesSuccess([]));
      } else {
        data = data.map((node, index) => ({ ...node, id: index }));
        dispatch(dashboardGetInmuebleDeviceNodesSuccess(data));
      }
    } catch (error) {
      dispatch(dashboardGetInmuebleDeviceNodesError(error));
    }
  };
}


export function toggleDarkMode(isDark) {
  return async (dispatch) => {
    dispatch(toggleDarkModeInit());
    dispatch(toggleDarkModeSuccess(isDark));
  };
}

export function setMetricThreshold() {
  return async (dispatch) => {
    try {
      dispatch(metricThresholdInit());
      const result = await getMetricThresholds();
      dispatch(metricThresholdSuccess(result));
    } catch (error) {
      dispatch(metricThresholdError(error));
    }
  };
}

const dashboardInit = () => ({ type: 'VIEW_DASHBOARD_INIT' });
const dashboardInitDevices = () => ({ type: 'VIEW_DASHBOARD_DEVICES_INIT' });
const dashboardInitFilters = () => ({ type: 'VIEW_DASHBOARD_FILTERS_INIT' });
const dashboardChartsInit = () => ({ type: 'VIEW_DASHBOARD_CHARTS_INIT' });
const dashboardFiltersSelectionInit = () => ({ type: 'SELECT_DASHBOARD_FILTERS_INIT' });
const dashboardNodeSelectionInit = () => ({ type: 'SELECT_DASHBOARD_NODE_INIT' });
const dashboardInterfaceSelectionInit = () => ({ type: dashboardInterfaceSelectionTypes.init });
const dashboardDrillInterfaceSelectionInit = () => ({ type: 'SELECT_DASHBOARD_DRILL_INTERFACE_INIT' });
const dashboardIrregularNodesInit = () => ({ type: dashboardIrregularNodesTypes.init });
const dashboardChartsThresholdsInit = () => ({ type: dashboardChartsThresholdsTypes.init });
const dashboardCaidasInit = () => ({ type: dashboardCaidasTypes.init });
const dashboardResponseTimeInit = () => ({ type: dashboardResponseTimeTypes.init });

const dashboardGeneralTableInit = () => ({ type: dashboardGeneralTableTypes.init });
const dashboardTopInterfacesInit = () => ({ type: dashboardTopInterfacesTypes.init });
const dashboardMetricInit = () => ({ type: dashboardMetricTypes.init });
const dashboardFirstSectionInit = () => ({ type: dashboardFirstSectionTypes.init });
const dashboardChartNodesInit = () => ({ type: dashboardChartNodesTypes.init });
const dashboardGetInmuebleDeviceNodesInit = () => ({ type: inmuebleDeviceNodesTypes.init });
const toggleDarkModeInit = () => ({ type: toggleDarkModeTypes.init });
const metricThresholdInit = () => ({ type: metricThresholdTypes.init });

const dashboardError = (error) => ({ type: 'VIEW_DASHBOARD_ERROR', payload: error });
const dashboardErrorDevices = (error) => ({ type: 'VIEW_DASHBOARD_DEVICES_ERROR', payload: error });
const dashboardErrorProperty = (error) => ({ type: 'VIEW_DASHBOARD_PROPERTY_ERROR', payload: error });
const dashboardErrorFirstSection = (error) => ({ type: dashboardFirstSectionTypes.error, payload: error });
const dashboardFiltersError = (error) => ({ type: 'VIEW_DASHBOARD_FILTERS_ERROR', payload: error });
const dashboardFiltersSelectionError = (error) => ({ type: 'SELECT_DASHBOARD_FILTERS_ERROR', payload: error });
const dashboardIrregularNodesError = (error) => ({ type: dashboardIrregularNodesTypes.error, payload: error });
const dashboardCaidasError = (error) => ({ type: dashboardCaidasTypes.error, payload: error });
const dashboardResponseTimeError = (error) => ({ type: dashboardResponseTimeTypes.error, payload: error });
const dashboardChartsThresholdsError = (error) => ({ type: dashboardChartsThresholdsTypes.error, payload: error });
const dashboardGeneralTableError = (error) => ({ type: dashboardGeneralTableTypes.error, payload: error });
const dashboardTopInterfacesError = (error) => ({ type: dashboardTopInterfacesTypes.error, payload: error });
const dashboardMetricError = (error) => ({ type: dashboardMetricTypes.error, payload: error });
const dashboardChartNodesError = (error) => ({ type: dashboardChartNodesTypes.error, payload: error });
const dashboardInterfaceSelectionError = (error) => ({ type: dashboardInterfaceSelectionTypes.error, payload: error });
const dashboardGetInmuebleDeviceNodesError = (error) => ({ type: inmuebleDeviceNodesTypes.error, payload: error });
const metricThresholdError = (error) => ({ type: metricThresholdTypes.error, payload: error });

const dashboardSuccess = (data) => ({ type: 'VIEW_DASHBOARD_SUCCESS', payload: data });
const dashboardDevicesSuccess = (data) => ({ type: 'VIEW_DASHBOARD_DEVICES_SUCCESS', payload: data });
const dashboardPropertySuccess = (data) => ({ type: 'VIEW_DASHBOARD_PROPERTY_SUCCESS', payload: data });
const dashboardFirstSectionSuccess = (data) => ({ type: dashboardFirstSectionTypes.success, payload: data });
const dashboardFiltersSuccess = (data) => ({ type: 'VIEW_DASHBOARD_FILTERS_SUCCESS', payload: data });
const dashboardFiltersSelectionSuccess = (data) => ({ type: 'SELECT_DASHBOARD_FILTERS_SUCCESS', payload: data });
const dashboardNodeSelectionSuccess = (data) => ({ type: 'SELECT_DASHBOARD_NODE_SUCCESS', payload: data });
const dashboardInterfaceSelectionSuccess = (data) => ({ type: dashboardInterfaceSelectionTypes.success, payload: data });
const dashboardDrillInterfaceSelectionSuccess = (data) => ({ type: 'SELECT_DASHBOARD_DRILL_INTERFACE_SUCCESS', payload: data });
const dashboardIrregularNodesSuccess = (data) => ({ type: dashboardIrregularNodesTypes.success, payload: data });
const dashboardCaidasSuccess = (data) => ({ type: dashboardCaidasTypes.success, payload: data });
const dashboardResponseTimeSuccess = (data) => ({ type: dashboardResponseTimeTypes.success, payload: data });
const dashboardGeneralTableSuccess = (data) => ({ type: dashboardGeneralTableTypes.success, payload: data });
const dashboardChartsThresholdsSuccess = (data) => ({ type: dashboardChartsThresholdsTypes.success, payload: data });
const dashboardTopInterfacesSuccess = (data) => ({ type: dashboardTopInterfacesTypes.success, payload: data });
const dashboardMetricSuccess = (data) => ({ type: dashboardMetricTypes.success, payload: data });
const dashboardChartNodesSuccess = (data) => ({ type: dashboardChartNodesTypes.success, payload: data });
const dashboardGetInmuebleDeviceNodesSuccess = (data) => ({ type: inmuebleDeviceNodesTypes.success, payload: data });
const toggleDarkModeSuccess = (data) => ({ type: toggleDarkModeTypes.success, payload: data });
const metricThresholdSuccess = (data) => ({ type: metricThresholdTypes.success, payload: data });

// NODE DETAILS ACTIONS
const nodeDetailsInterfacesInit = () => ({ type: nodeDetailsInterfacesTypes.init });
const nodeDetailsGeneralInfoInit = () => ({ type: nodeDetailsGeneralInfoTypes.init });
const nodeDetailsPercentAvailabilityInit = () => ({ type: nodeDetailsPercentAvailabilityTypes.init });
const nodeDetailsSetFiltersInit = () => ({ type: nodeDetailsSetFiltersTypes.init });

const nodeDetailsInterfacesSuccess = (data) => ({ type: nodeDetailsInterfacesTypes.success, payload: data });
const nodeDetailsGeneralInfoSuccess = (data) => ({ type: nodeDetailsGeneralInfoTypes.success, payload: data });
const nodeDetailsPercentAvailabilitySuccess = (data) => ({ type: nodeDetailsPercentAvailabilityTypes.success, payload: data });
const nodeDetailsSetFiltersSuccess = (data) => ({ type: nodeDetailsSetFiltersTypes.success, payload: data });

const nodeDetailsIndicatorsError = (error) => ({ type: nodeDetailsInterfacesTypes.error, payload: error });
const nodeDetailsGeneralInfoError = (error) => ({ type: nodeDetailsGeneralInfoTypes.error, payload: error });
const nodeDetailsPercentAvailabilityError = (error) => ({ type: nodeDetailsPercentAvailabilityTypes.error, payload: error });
const nodeDetailsSetFiltersError = (error) => ({ type: nodeDetailsSetFiltersTypes.error, payload: error });

const initialState = {
  name: 'dashboard',
  state: false,
  loading: true,
  loadingDevices: false,
  loadingCharts: false,
  loadingFirstSection: true,
  loadingTopInterfaces: true,
  loadingGeneralTable: true,
  loadingIrregularNodes: true,
  loadingCaidasNodes: true,
  loadingResponseTimeNodes: true,
  loadingFilters: true,
  loadingMetrics: true,
  loadingChartNodes: false,
  loadingMetricCharts: false,
  dashboard: {
    firstSection: [
      {
        total: `Cargando...`,
        up: 0,
        down: 0,
        warning: 0,
        unregistered: 0,
      },
      {
        total: `Cargando...`,
        up: 0,
        down: 0,
        warning: 0,
        unregistered: 0,
      },
      {
        total: `Cargando...`,
        up: 0,
        down: 0,
        warning: 0,
        unregistered: 0,
      },
      {
        total: `Cargando...`,
        up: 0,
        down: 0,
        warning: 0,
        unregistered: 0,
      },
    ],
    charts: {
      gruposInmueble: [],
      tipoInmuebles: [],
    },
    devices: {},
    filters: {
      regiones: [],
      inmuebles: [],
      grupos: [],
      nodos: [],
      fechaFin: null,
      fechaIni: null,
      filtersSelected: {
        // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
        // fechaIni: moment().subtract(10, 'minutes').format('Y-MM-DD HH:mm:00'),
        fechaFin: null,
        fechaIni: null,
      },
    },
    irregularNodes: {
      highMemoryUsage: [],
      highCpuUsage: [],
      unavailable: [],
      highLossPackage: [],
    }, // IRREGULAR NODES
    caidasNodes: [],
    responseTimeNodes: [],
    redirectPath: '/dashboard', // PATH TO REDIRECT USER FROM NODE DETAILS VIEW
    metricsGraphic: {
      // DATA TO DISPLAY IN THE DASHBOARD METRIC GRAPHICS
      nodeSelected: null,
      interfaces: [],
      metricasGraphicData: [],
      anchoBandaGraphicData: {},
      avgAnchoBandaGraphicData: {},
    },
    interfaceEquipments: [], // EQUIPMENTS SELECTED FROM INTERFACE IN DRILL NODE VIEW
    generalTable: [], // DATA OF THE GENERAL TABLE FOR NODES
    topInterfaces: [], // TOP 10 INTERFACES
    metrics: [], // METRICS
    chartNodes: [], // NODES WHEN SELECTING INMUEBLE/GRUPO CHART
    indicators: {
      nodes: [], // NODES FROM DEVICE OR INMUEBLE WHEN SELECTING INMUEBLE/DEVICE STATUS,
      loading: false,
    },
  },
  nodeDetails: {
    loadingInterfaces: false,
    loadingGeneralInfo: false,
    loadingPercentAvailability: false,
    interfaces: [],
    generalInfo: {},
    percentAvailability: [],
    filtersSelected: {
      fechaFin: moment().format('Y-MM-DD HH:mm:00'),
      fechaIni: moment().subtract(10, 'minutes').format('Y-MM-DD HH:mm:00'),
    },
    metricsGraphic: {
      // DATA TO DISPLAY IN THE DRILL DOWN METRIC GRAPHICS
      nodeSelected: null,
      interfaces: [],
      metricasGraphicData: [],
      anchoBandaGraphicData: {},
      metricsInterfaceData:{}
    },
  },
  metricThresholds: {
    ...metricThresholds,
  },
  metricThresholdsCharts:{},
  darkMode: true,
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case 'VIEW_DASHBOARD_INIT':
      return {
        ...state,
        loading: true,
        loadingDevices: true,
        loadingCharts: true,
        loadingFirstSection: true,
        loadingTopInterfaces: true,
        loadingGeneralTable: true,
        loadingIrregularNodes: true,
        loadingResponseTimeNodes: true,
        loadingCaidasNodes: true,
        loadingThresholds: true,
        loadingFilters: true,
      };
    case 'VIEW_DASHBOARD_DEVICES_INIT':
      return {
        ...state,
        loadingDevices: true,
        loadingCharts: false,
      };
    case 'VIEW_DASHBOARD_CHARTS_INIT':
      return {
        ...state,
        loadingDevices: false,
        loadingCharts: true,
      };
    case 'SELECT_DASHBOARD_FILTER_INIT':
      return {
        ...state,
        loading: true,
      };
    case dashboardIrregularNodesTypes.init:
      return {
        ...state,
        loadingIrregularNodes: true,
      };
    case dashboardCaidasTypes.init:
      return {
        ...state,
        loadingCaidasNodes: true,
      };
    case dashboardResponseTimeTypes.init:
      return {
        ...state,
        loadingResponseTimeNodes: true,
      };
    case dashboardChartsThresholdsTypes.init:
        return {
          ...state,
          loadingThresholds: true,
        };
    case dashboardGeneralTableTypes.init:
      return {
        ...state,
        loadingGeneralTable: true,
      };
    case dashboardFirstSectionTypes.init:
      return {
        ...state,
        loadingFirstSection: true,
      };
    case dashboardTopInterfacesTypes.init:
      return {
        ...state,
        loadingTopInterfaces: true,
      };
    case dashboardChartNodesTypes.init:
      return {
        ...state,
        loadingChartNodes: true,
      };
    case dashboardInterfaceSelectionTypes.init:
      return {
        ...state,
        loadingMetricCharts: true,
      };
    case nodeDetailsGeneralInfoTypes.init:
      return {
        ...state,
        loadingMetricCharts: true,
      };
    case nodeDetailsInterfacesTypes.init:
      return {
        ...state,
        nodeDetails: {
          ...state.nodeDetails,
          loadingInterfaces: true,
        },
      };
    case nodeDetailsPercentAvailabilityTypes.init:
      return {
        ...state,
        nodeDetails: {
          ...state.nodeDetails,
          loadingPercentAvailability: true,
        },
      };
    case inmuebleDeviceNodesTypes.init:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          indicators: {
            ...state.dashboard.indicators,
            loading: true,
          },
        },
      };
    case 'VIEW_DASHBOARD_SUCCESS':
      return {
        ...state,
        loading: false,
        dashboard: action.payload,
      };
    case 'VIEW_DASHBOARD_DEVICES_SUCCESS':
      return {
        ...state,
        loadingDevices: false,
        dashboard: {
          ...state.dashboard,
          charts: {
            ...action.payload,
          },
        },
      };
    case 'VIEW_DASHBOARD_PROPERTY_SUCCESS':
      return {
        ...state,
        loading: false,
        dashboard: {
          ...state.dashboard,
          charts: {
            property: action.payload,
            devices: state?.dashboard?.charts?.devices,
          },
        },
      };
    case dashboardFirstSectionTypes.success:
      return {
        ...state,
        loadingFirstSection: false,
        dashboard: {
          ...state.dashboard,
          firstSection: action.payload,
        },
        errorDashboard: null,
      };
    case 'VIEW_DASHBOARD_FILTERS_SUCCESS':
      return {
        ...state,
        loading: false,
        loadingFilters: false,
        dashboard: {
          ...state.dashboard,
          filters: {
            ...state.dashboard.filters,
            ...action.payload,
          },
        },
      };
    case 'SELECT_DASHBOARD_FILTERS_SUCCESS':
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          filters: {
            ...state.dashboard.filters,
            filtersSelected: action.payload,
          },
        },
      };
    case dashboardInterfaceSelectionTypes.success:
      return {
        ...state,
        loadingMetricCharts: false,
        dashboard: {
          ...state.dashboard,
          metricsGraphic: action.payload,
        },
      };
    case 'SELECT_DASHBOARD_NODE_SUCCESS':
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          redirectPath: action.payload.redirectPath,
        },
        nodeDetails: {
          ...state.nodeDetails,
          metricsGraphic: {
            ...state.nodeDetails.metricsGraphic,
            nodeSelected: action.payload.nodeSelected,
          },
        },
      };
    case 'SELECT_DASHBOARD_DRILL_INTERFACE_SUCCESS':
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          interfaceEquipments: action.payload,
        },
      };
    case dashboardCaidasTypes.success:
      return {
        ...state,
        loadingCaidasNodes: false,
        dashboard: {
          ...state.dashboard,
          caidasNodes: action.payload,
        },
      };
    case dashboardResponseTimeTypes.success:
      return {
        ...state,
        loadingResponseTimeNodes: false,
        dashboard: {
          ...state.dashboard,
          responseTimeNodes: action.payload,
        },
      };
    case dashboardChartsThresholdsTypes.success:
      return {
        ...state,
        loadingThresholds: false,
        dashboard: {
          ...state.dashboard,
          metricThresholdsCharts: action.payload,
        },
      };
    case dashboardIrregularNodesTypes.success:
      return {
        ...state,
        loadingIrregularNodes: false,
        dashboard: {
          ...state.dashboard,
          irregularNodes: action.payload,
        },
      };
    case dashboardGeneralTableTypes.success:
      return {
        ...state,
        loadingGeneralTable: false,
        dashboard: {
          ...state.dashboard,
          generalTable: action.payload,
        },
      };
    case dashboardTopInterfacesTypes.success:
      return {
        ...state,
        loadingTopInterfaces: false,
        dashboard: {
          ...state.dashboard,
          topInterfaces: action.payload,
        },
      };
    case dashboardMetricTypes.success:
      return {
        ...state,
        loadingMetrics: false,
        dashboard: {
          ...state.dashboard,
          metrics: action.payload,
        },
      };
    case dashboardChartNodesTypes.success:
      return {
        ...state,
        loadingChartNodes: false,
        dashboard: {
          ...state.dashboard,
          chartNodes: action.payload,
        },
      };
    case nodeDetailsGeneralInfoTypes.success:
      return {
        ...state,
        loadingMetricCharts: false,
        nodeDetails: {
          ...state.nodeDetails,
          ...action.payload,
        },
      };
    case nodeDetailsInterfacesTypes.success:
      return {
        ...state,
        nodeDetails: {
          ...state.nodeDetails,
          interfaces: action.payload,
          loadingInterfaces: false,
        },
      };
    case nodeDetailsPercentAvailabilityTypes.success:
      return {
        ...state,
        nodeDetails: {
          ...state.nodeDetails,
          percentAvailability: action.payload,
          loadingPercentAvailability: false,
        },
      };
    case nodeDetailsSetFiltersTypes.success:
      return {
        ...state,
        nodeDetails: {
          ...state.nodeDetails,
          filtersSelected: action.payload,
        },
      };
    case inmuebleDeviceNodesTypes.success:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          indicators: {
            loading: false,
            nodes: action.payload,
          },
        },
      };
    case toggleDarkModeTypes.success:
      return {
        ...state,
        darkMode: action.payload,
      };
    case metricThresholdTypes.success:
      return {
        ...state,
        metricThresholds: action.payload,
      };
    case dashboardFirstSectionTypes.error:
      return {
        ...state,
        loadingFirstSection: false,
        errorDashboard: action.payload,
      };
    case 'VIEW_DASHBOARD_DEVICES_ERROR':
      return {
        ...state,
        loadingDevices: false,
        errorDevice: action.payload,
      };
    case 'VIEW_DASHBOARD_PROPERTY_ERROR':
      return {
        ...state,
        loadingCharts: false,
        errorChart: action.payload,
      };
    case 'VIEW_DASHBOARD_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'VIEW_DASHBOARD_FILTERS_ERROR':
      return {
        ...state,
        errorFilters: action.payload,
        loadingFilters: false,
      };
    case dashboardIrregularNodesTypes.error:
      return {
        ...state,
        loadingIrregularNodes: false,
        errorIrregularNodes: action.payload,
      };
    case dashboardCaidasTypes.error:
      return {
        ...state,
        loadingCaidasNodes: false,
        erroCaidasNodes: action.payload,
      };
    case dashboardChartsThresholdsTypes.error:
      return {
        ...state,
        loadingThresholds: false,
        errorThresholdsNodes: action.payload,
      };
    case dashboardResponseTimeTypes.error:
      return {
        ...state,
        loadingResponseTimeNodes: false,
        erroResponseeTimeNodes: action.payload,
      };
    case dashboardGeneralTableTypes.error:
      return {
        ...state,
        loadingGeneralTable: false,
        errorTablaGeneral: action.payload,
        dashboard: {
          ...state.dashboard,
          generalTable: [],
        },
      };
    case dashboardTopInterfacesTypes.error:
      return {
        ...state,
        loadingTopInterfaces: false,
        errorTopInterfaces: action.payload,
      };
    case dashboardMetricTypes.error:
      return {
        ...state,
        loadingMetrics: false,
        errorMetrics: action.payload,
      };
    case dashboardChartNodesTypes.error:
      return {
        ...state,
        loadingChartNodes: false,
        errorChartNodes: action.payload,
        dashboard: {
          ...state.dashboard,
          chartNodes: [],
        },
      };
    case nodeDetailsPercentAvailabilityTypes.error:
      return {
        ...state,
        nodeDetails: {
          ...state.nodeDetails,
          errorPercentAvailability: action.payload,
          loadingPercentAvailability: false,
        },
      };
    case dashboardInterfaceSelectionTypes.error:
      return {
        ...state,
        loadingMetricCharts: false,
      };
    case nodeDetailsInterfacesTypes.error:
      return {
        ...state,
        loadingMetricCharts: false,
        loadingInterfaces: false,
      };
    case inmuebleDeviceNodesTypes.error:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          indicators: {
            loading: false,
            nodes: [],
          },
        },
      };
    default:
      return {
        ...state,
      };
  }
}
